module.exports = __webpack_public_path__ + "img/clienti_add.2f485959.png";